import { useState } from "react";
import { URL_API } from "../config/default";
import Swal, { SweetAlertOptions } from "sweetalert2";
import Title from "../components/UI/Title";
import Spinner from "../components/UI/Spinner/Spinner";
import { useSearchParams } from "react-router-dom";

const Verificar = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [loading, setLoading] = useState(false);
  const [auth, setAuth] = useState<any>({
    password: "",
    repeat_password: "",
  });

  const submit = async () => {
    setLoading(true);

    if(
        auth.password !== auth.repeat_password
    ){
        return "";
    }
    
    const formdata = new FormData();
    formdata.append("password", auth.password);
    formdata.append("repeat_password", auth.repeat_password);
    formdata.append("token", String(token));

    const requestOptions = {
      method: "POST",
      body: formdata,
    };

    fetch(`${URL_API}/auth/verify-password`, requestOptions)
      .then(async (response) => {
        const result = await response.json();
        localStorage.removeItem("token");
        localStorage.setItem("token", result.token);
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);
        Toast.fire({
          icon: "success",
          title: "Ingreso exitoso!",
        });
        setLoading(false);
        return (window.location.href = "/");
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  console.log(token);
  return (
    <div className="mt-4">
      <Title text="Recupera tu contraseña" />
      <hr className="mx-auto text-primary " />
      <div className="py-6 text-center font-bold text-base">
        Puedes cambiar tu contraseña en un plazo de 24hrs desde que se envio el
        mail
      </div>
      <div className="w-full  mb-4 px-[30px]">
        <div>
          <div className="py-2">
            <div className="mb-4">
              <div>
                <input
                  name="pass"
                  type="password"
                  placeholder="Contraseña"
                  className="border border-gray-300 text-gray-900 sm:text-sm mb-3 rounded-xl focus:ring-primary-600
                   focus:border-primary-600 block w-full p-2.5 placeholder:text-gray-500 placeholder:font-bold"
                  onChange={(e) =>
                    setAuth({ ...auth, password: e.target.value })
                  }
                />

                <input
                  name="pass"
                  type="password"
                  placeholder="Repite tu contraseña"
                  className="border border-gray-300 text-gray-900 sm:text-sm rounded-xl  focus:ring-primary-600
                   focus:border-primary-600 block w-full p-2.5 placeholder:text-gray-500 placeholder:font-bold"
                  onChange={(e) =>
                    setAuth({ ...auth, repeat_password: e.target.value })
                  }
                />
              </div>
            </div>

            <label className="cursor-pointer btn bg-primary text-white font-bold w-full block text-center py-3 rounded-xl text-xl flex justify-center items-center">
              {loading ? <Spinner /> : <span>Continuar</span>}
              <button className="hidden" onClick={() => submit()}></button>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verificar;
